class CartSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = document.querySelectorAll(".cart-slide");
  }

  connectedCallback() {
    this.currentWidth = window.innerWidth;
    this.initSlider();

    window.addEventListener("resize", this.handleResize.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize.bind(this));
  }

  initSlider() {
    if (this.flkty) {
      this.flkty.destroy();
    }
    if (this.slides.length <= 1) {
      return;
    }
    this.flkty = new Flickity(this, {
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      cellAlign: "center",
    });
  }

  handleResize() {
    if (this.currentWidth !== window.innerWidth) {
      this.currentWidth = window.innerWidth;
      this.initSlider();
    }
  }
}

customElements.define("cart-slider", CartSlider);
